import { BaggageRollIcon, CertifiedRibbonIcon, FastTrackIcon, MoneyIncomingIcon, PlaneTicketReturnIcon, RefreshIcon, RestaurantSeatIcon, SeatRegularIcon, TravelInsuranceIcon, TreeIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { t } from "@bookingcom/lingojs-core";
import { includedBaggageIcons } from "./icons.js";
export const CABIN_CLASS_ORDER = [
    "ECONOMY",
    "PREMIUM_ECONOMY",
    "BUSINESS",
    "PREMIUM_BUSINESS",
    "FIRST",
    "PREMIUM_FIRST"
];
export const BAGGAGE_FEATURE_NAMES = {
    PERSONAL_ITEM: "PERSONAL_BAGGAGE",
    CHECKED_IN: "CHECK_BAGGAGE",
    HAND: "CABIN_BAGGAGE"
};
export const BRANDED_FARE_FEATURES_CONFIG = [
    {
        name: BAGGAGE_FEATURE_NAMES.PERSONAL_ITEM,
        icon: includedBaggageIcons.PERSONAL_ITEM,
        group: "BAGGAGE"
    },
    {
        name: BAGGAGE_FEATURE_NAMES.HAND,
        icon: includedBaggageIcons.HAND,
        group: "BAGGAGE"
    },
    {
        name: BAGGAGE_FEATURE_NAMES.CHECKED_IN,
        icon: includedBaggageIcons.CHECKED_IN,
        group: "BAGGAGE"
    },
    {
        name: "CHANGE_FEE",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_055_incl"),
        sellableFeatureCopy: t("flights_branded_fare_055_sell"),
        nonIncludedFeatureCopy: t("flights_apex_flight_change_excl_generic"),
        group: "FLEXIBILITY"
    },
    {
        name: "CHANGEABLE_TICKET",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_059_incl"),
        sellableFeatureCopy: t("flights_branded_fare_059_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_059_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "CHANGE_ANYTIME",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_068_incl"),
        sellableFeatureCopy: t("flights_branded_fare_068_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_069_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "CHANGE_BEFORE_DEPARTURE",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_06i_incl"),
        sellableFeatureCopy: t("flights_branded_fare_06i_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_06i_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "CHANGE_AFTER_DEPARTURE",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_06j_incl"),
        sellableFeatureCopy: t("flights_branded_fare_06j_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_06j_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "SAME_DAY_CHANGE",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_08s_incl"),
        sellableFeatureCopy: t("flights_apex_fare_feature_change_sell_generic"),
        nonIncludedFeatureCopy: t("flights_apex_flight_change_excl_generic"),
        group: "FLEXIBILITY"
    },
    {
        name: "SAME_DAY_AS_ORIGINAL_FLT",
        icon: PlaneTicketReturnIcon,
        includedFeatureCopy: t("flights_branded_fare_08r_incl"),
        sellableFeatureCopy: t("flights_apex_fare_feature_change_sell_generic"),
        nonIncludedFeatureCopy: t("flights_apex_flight_change_excl_generic"),
        group: "FLEXIBILITY"
    },
    {
        name: "REFUNDABLE_TICKET",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_branded_fare_056_incl"),
        sellableFeatureCopy: t("flights_branded_fare_056_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_056_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "REFUND_BEFORE_DEPARTURE",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_branded_fare_06k_incl"),
        sellableFeatureCopy: t("flights_branded_fare_06k_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_06k_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "REFUND_AFTER_DEPARTURE",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_branded_fare_06l_incl"),
        sellableFeatureCopy: t("flights_branded_fare_06l_sell"),
        nonIncludedFeatureCopy: t("flights_branded_fare_06l_excl"),
        group: "FLEXIBILITY"
    },
    {
        name: "REFUND_WITH_CREDIT_6_MONTHS",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_bf_southwest_basic_refund"),
        group: "FLEXIBILITY"
    },
    {
        name: "REFUND_WITH_TRANSFERABLE_CREDIT_12_MONTHS",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_bf_southwest_choice_refund"),
        group: "FLEXIBILITY"
    },
    {
        name: "PRE_RESERVED_SEAT_ASSIGNMENT",
        icon: SeatRegularIcon,
        includedFeatureCopy: t("flights_fare_feature_0b5"),
        nonIncludedFeatureCopy: t("flights_apex_fare_feature_0b5_excluded"),
        sellableFeatureCopy: t("flights_apex_fare_feature_0b5_sellable"),
        includedFeatureCopyAlt: t("flights_bf_seats_0b5_incl"),
        sellableFeatureCopyAlt: t("flights_bf_seats_0b5_sell"),
        nonIncludedFeatureCopyAlt: t("flights_bf_seats_excl"),
        group: "ON_THE_FLIGHT"
    },
    {
        name: "BASIC_SEAT",
        icon: SeatRegularIcon,
        includedFeatureCopy: t("flights_fare_feature_050"),
        nonIncludedFeatureCopy: t("flights_fare_feature_050_excluded"),
        sellableFeatureCopy: t("flights_apex_fare_feature_050_sellable"),
        includedFeatureCopyAlt: t("flights_bf_seats_05o_incl"),
        sellableFeatureCopyAlt: t("flights_bf_seats_05o_sell"),
        nonIncludedFeatureCopyAlt: t("flights_bf_seats_excl"),
        group: "ON_THE_FLIGHT"
    },
    {
        name: "PREMIUM_SEAT",
        icon: SeatRegularIcon,
        includedFeatureCopy: t("flights_fare_feature_057"),
        nonIncludedFeatureCopy: t("flights_apex_fare_feature_05z_excluded"),
        sellableFeatureCopy: t("flights_apex_fare_feature_05z_sellable"),
        includedFeatureCopyAlt: t("flights_bf_seats_05z_incl"),
        sellableFeatureCopyAlt: t("flights_bf_seats_05z_sell"),
        nonIncludedFeatureCopyAlt: t("flights_bf_seats_excl"),
        group: "ON_THE_FLIGHT"
    },
    {
        name: "PREMIUM_OR_BASIC_SEAT",
        icon: SeatRegularIcon,
        sellableFeatureCopy: t("flights_bf_seats_sellable"),
        group: "ON_THE_FLIGHT"
    },
    {
        name: "DELAYED_ARRIVAL_WARRANTY",
        icon: TravelInsuranceIcon,
        includedFeatureCopy: t("flights_fare_feature_030"),
        nonIncludedFeatureCopy: t("flights_fare_feature_030_excluded")
    },
    {
        name: "DATE_CHANGE_WARRANTY",
        icon: TravelInsuranceIcon,
        includedFeatureCopy: t("flights_fare_feature_03r"),
        nonIncludedFeatureCopy: t("flights_fare_feature_03r_excluded")
    },
    {
        name: "NO_SHOW_FEE",
        icon: MoneyIncomingIcon,
        includedFeatureCopy: t("flights_fare_feature_0nn"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0nn_excluded")
    },
    {
        name: "NAME_CHANGE",
        icon: RefreshIcon,
        includedFeatureCopy: t("flights_fare_feature_0l7"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0l7_excluded")
    },
    {
        name: "PREMIUM_TRIP_INSURANCE",
        icon: TravelInsuranceIcon,
        includedFeatureCopy: t("flights_fare_feature_0pm"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0pm_excluded")
    },
    {
        name: "TRIP_INSURANCE",
        icon: TravelInsuranceIcon,
        includedFeatureCopy: t("flights_fare_feature_0bg"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0bg_excluded")
    },
    {
        name: "PRIORITY_BAGGAGE",
        icon: BaggageRollIcon,
        includedFeatureCopy: t("flights_fare_feature_0lf"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0lf_excluded")
    },
    {
        name: "FAST_TRACK",
        icon: FastTrackIcon,
        includedFeatureCopy: t("flights_fare_feature_029"),
        nonIncludedFeatureCopy: t("flights_fare_feature_029_excluded")
    },
    {
        name: "PRIORITY_CHECK_IN",
        icon: FastTrackIcon,
        includedFeatureCopy: t("flights_fare_feature_03p"),
        nonIncludedFeatureCopy: t("flights_fare_feature_03p_excluded"),
        group: "AT_THE_AIRPORT"
    },
    {
        name: "PRIORITY_BOARDING",
        icon: FastTrackIcon,
        includedFeatureCopy: t("flights_fare_feature_0gc"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0gc_excluded"),
        group: "AT_THE_AIRPORT"
    },
    {
        name: "PRIORITY_SECURITY",
        icon: FastTrackIcon,
        includedFeatureCopy: t("flights_fare_feature_0lw"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0lw_excluded"),
        group: "AT_THE_AIRPORT"
    },
    {
        name: "LOUNGE_ACCESS",
        icon: RestaurantSeatIcon,
        includedFeatureCopy: t("flights_fare_feature_0bx"),
        nonIncludedFeatureCopy: t("flights_fare_feature_0bx_excluded"),
        group: "AT_THE_AIRPORT"
    },
    { name: "CARBON_OFFSET", icon: TreeIcon },
    {
        name: "MILEAGE_ACCRUAL",
        icon: CertifiedRibbonIcon,
        includedFeatureCopy: t("flights_apex_fare_feature_057"),
        nonIncludedFeatureCopy: t("flights_apex_fare_feature_057_excluded")
    }
];
export const CHANGEABLE_TICKET_FEATURES = [
    "CHANGEABLE_TICKET",
    "CHANGE_ANYTIME",
    "CHANGE_BEFORE_DEPARTURE",
    "CHANGE_AFTER_DEPARTURE"
];
export const REFUNDABLE_TICKET_FEATURES = [
    "REFUNDABLE_TICKET",
    "REFUND_BEFORE_DEPARTURE",
    "REFUND_AFTER_DEPARTURE"
];
export const CHANGE_FEATURES = [
    "CHANGE_FEE",
    "CHANGEABLE_TICKET",
    "CHANGE_ANYTIME",
    "CHANGE_BEFORE_DEPARTURE",
    "CHANGE_AFTER_DEPARTURE",
    "SAME_DAY_CHANGE",
    "SAME_DAY_AS_ORIGINAL_FLT"
];
export const CHANGE_FEATURE_PRIORITY = [
    { featureName: "CHANGEABLE_TICKET", availability: "INCLUDED" },
    { featureName: "CHANGE_ANYTIME", availability: "INCLUDED" },
    { featureName: "CHANGE_BEFORE_DEPARTURE", availability: "INCLUDED" },
    { featureName: "CHANGE_FEE", availability: "INCLUDED" },
    { featureName: "CHANGEABLE_TICKET", availability: "SELLABLE" },
    { featureName: "CHANGE_ANYTIME", availability: "SELLABLE" },
    { featureName: "CHANGE_BEFORE_DEPARTURE", availability: "SELLABLE" },
    { featureName: "CHANGE_FEE", availability: "SELLABLE" },
    { featureName: "CHANGEABLE_TICKET", availability: "NOT_INCLUDED" },
    { featureName: "CHANGE_ANYTIME", availability: "NOT_INCLUDED" },
    { featureName: "CHANGE_AFTER_DEPARTURE", availability: "NOT_INCLUDED" },
    { featureName: "CHANGE_BEFORE_DEPARTURE", availability: "NOT_INCLUDED" }
];
export const CHANGE_FEATURE_EXCLUSIONS = [
    { featureName: "CHANGE_FEE", availability: "NOT_INCLUDED" },
    { featureName: "SAME_DAY_CHANGE", availability: "NOT_INCLUDED" },
    { featureName: "SAME_DAY_AS_ORIGINAL_FLT", availability: "NOT_INCLUDED" },
    { featureName: "SAME_DAY_CHANGE", availability: "SELLABLE" },
    { featureName: "SAME_DAY_AS_ORIGINAL_FLT", availability: "SELLABLE" }
];
export const CANCELLATION_FEATURE_PRIORITY = [
    { featureName: "REFUNDABLE_TICKET", availability: "INCLUDED" },
    { featureName: "REFUND_BEFORE_DEPARTURE", availability: "INCLUDED" },
    { featureName: "REFUND_AFTER_DEPARTURE", availability: "INCLUDED" },
    { featureName: "REFUNDABLE_TICKET", availability: "SELLABLE" },
    { featureName: "REFUND_BEFORE_DEPARTURE", availability: "SELLABLE" },
    { featureName: "REFUND_AFTER_DEPARTURE", availability: "SELLABLE" },
    { featureName: "REFUNDABLE_TICKET", availability: "NOT_INCLUDED" },
    { featureName: "REFUND_BEFORE_DEPARTURE", availability: "NOT_INCLUDED" },
    { featureName: "REFUND_AFTER_DEPARTURE", availability: "NOT_INCLUDED" }
];
export const APPS_BF_UPSELL_IMAGE_URL_MAP = {
    DEFAULT_BAGGAGE_IMAGE: "https://q-xx.bstatic.com/xdata/images/xphoto/max2048/592241541.jpg?k=f2d70f0071a8e831d1f55b6f740afc8432044c3edc70070c77aa020016b030ad&o=",
    SOLO_BAGGAGE_IMAGE: "https://q-xx.bstatic.com/xdata/images/xphoto/max2048/613482083.jpg?k=f8e42a6b3eb9496d758b969f80e410908e4a1851486b4d5b0afa9cdadd9b0912&o=",
    COUPLE_BAGGAGE_IMAGE: "https://q-xx.bstatic.com/xdata/images/xphoto/max2048/613483777.jpg?k=60472df13043a9e08c68b098d7398b357a8516827fcfe657f961e98f28ae3c5d&o=",
    GROUP_BAGGAGE_IMAGE: "https://q-xx.bstatic.com/xdata/images/xphoto/max2048/613127999.jpg?k=96ade22448b67b1c067e02bda57f97aa5689e7cabf387794103c9d9e3fdb11df&o=",
    WITH_KIDS_BAGGAGE_IMAGE: "https://q-xx.bstatic.com/xdata/images/xphoto/max2048/613483592.jpg?k=192aa6db7ca96372b57fbd8acaa6eb0aee996085fc021c95922926228e058131&o="
};
